import sendLocalRequest from "./sendLocalRequest";

export const getMachineConnectionStatus = (auth_token, uniqueId) => {
    return  new Promise( (resolve, reject) => {
        // console.log("contacting: " + `machines/connection_status/${uniqueId}`);
        sendLocalRequest(`machines/connection_status/${uniqueId}`, "GET", auth_token).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
